import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import { inject } from 'vue';
import { isFunction } from 'lodash';
import { useI18n } from 'vue-i18n';
import { useEmitter } from '@rednex/gateway_core';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { watch } from 'vue';
//--- Function imports

//### Service imports
import AccountService from '@/account/account.service';
//--- Service imports

//### Model imports
//--- Model imports

//### Component imports
import { SidebarMenu } from 'vue-sidebar-menu';
//--- Component imports

//### External Properties
//--- External Properties

//### Setup

export default /*#__PURE__*/_defineComponent({
  __name: 'sidebar',
  setup(__props) {

//### Function imports
const accountService = inject<AccountService>('accountService');

const i18n = useI18n();
const emitter = useEmitter();
const route = useRoute();
const store = useStore();
//--- Setup

//### Store/Reactive Data
const isIphone = computed(() => store.getters.isIphone);
const isPhoneDevice = computed(() => store.getters.isPhoneDevice);
const isTabletDevice = computed(() => store.getters.isTabletDevice);
const menuExpanded = computed(() => store.getters.menuExpanded);

watch(route, () => {
  getRouteAndCreateMenu();
});
//--- Store/Reactive Data

//### Variables const let
//--- Variables const let

//### Component Lifecycle
//--- Component Lifecycle

//### Functions
function getRouteAndCreateMenu() {
  const menu = [];
  const authorities = store.getters.currentUser?.authorities;

  if (authorities) {
    if (accountService.hasRole('ADMIN')) {
      menu.push({
        title: i18n.t('menu.admin.main'),
        icon: 'fa fa-toolbox',
        child: [
          // {
          //   href: '/admin/user-management',
          //   icon: 'fa fa-user',
          //   title: i18n.t('menu.admin.userManagement'),
          // },
          {
            href: '/admin/documents',
            icon: 'fa fa-toolbox',
            title: i18n.t('menu.admin.documents'),
          },
        ],
      });
    }
  } else {
    menu.push(
      {
        href: '/',
        icon: 'fa fa-person-biking',
        title: i18n.t('menu.user.bestLapAllRiders'),
      },
      {
        href: '/mylaptimes',
        icon: 'fa fa-person',
        title: i18n.t('menu.user.myLapTimes'),
      },
      {
        href: '/grids',
        icon: 'fa fa-sort-numeric-asc',
        title: i18n.t('menu.user.grids'),
      },
      {
        href: '/racelive',
        icon: 'fa fa-motorcycle',
        title: i18n.t('menu.user.raceLive'),
      },
      {
        href: '/raceresults',
        icon: 'fa fa-trophy',
        title: i18n.t('menu.user.raceResults'),
      },
      {
        href: '/timeschedule',
        icon: 'fa fa-list',
        title: i18n.t('menu.user.timeSchedule'),
      },
      {
        href: '/info',
        icon: 'fa fa-house',
        title: i18n.t('menu.user.info'),
      },
    );
  }

  return menu;
}

function onItemClick() {
  emitter.emit('close-sidebar');
}

function touchHandler(event) {
  // Workaround: on mobile device this will cause a double click on menu item !
  if (isIphone.value && (isPhoneDevice.value || isTabletDevice.value)) {
    if (isFunction(event.target.click)) {
      event.target.click();
    }
  }
}
//--- Functions

return (_ctx: any,_cache: any) => {
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createVNode(_unref(SidebarMenu), {
      onItemClick: onItemClick,
      collapsed: false,
      menu: getRouteAndCreateMenu(),
      hideToggle: true,
      showOneChild: true
    }, null, 8 /* PROPS */, ["menu"]), [
      [_directive_touch, touchHandler]
    ])
  ]))
}
}

})